import axios from "axios";

import { BASE_URL } from "@/configs";
import { API_URLS } from "@/constants";
import { dispatch, login, takeLegacySessionToken } from "@/store";
import { User } from "@/types";

let restoring: Promise<void> | null = null;

/**
 * Once per page load: the admin session back from the httpOnly cookie, if there is a live one.
 * Plain axios, not apiRequest: an empty answer must not trigger the dead-session redirect.
 */
export const restoreSession = (): Promise<void> =>
  (restoring ??= (async () => {
    try {
      const legacy = takeLegacySessionToken();
      const { data } = await axios.post<{ user: User | null; token: string | null }>(
        `${BASE_URL}/api-admin/${API_URLS.AUTH.REFRESH}`,
        {},
        {
          withCredentials: true,
          timeout: 15000,
          headers: legacy ? { Authorization: `Bearer ${legacy}` } : {},
        },
      );
      if (data?.token && data.user) dispatch(login({ user: data.user, token: data.token }));
    } catch (error) {
      // Signed out is a working state: the login page is the way back in.
      console.warn("Session restore failed:", error);
    }
  })());
